import React, {Component}  from "react";
import PropTypes from 'prop-types';
import {arrayMove} from "react-sortable-hoc";
import SortableList from './SortableList';

class SortableChapters extends Component {

    state = {
        parts: this.props.parts ? [...this.props.parts.filter(p => p !== null)] : [],
        selectedEditChapterPartId: ''
    };

    //Actions
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState({
            parts: arrayMove(this.state.parts, oldIndex, newIndex)
        }, e => {
            let parts = this.state.parts.map((p, i) => {
                return {id: p.id, number: i}
            });
            this.props.reorderChapterParts(parts, this.props.user.id);
        });
    };

    setSelectedEditChapterPartId = (id) => {
        if (id !== this.state.selectedEditChapterPartId) {
            this.setState({
                selectedEditChapterPartId: id
            });
        } else {
            this.setState({
                selectedEditChapterPartId: ''
            });
        }
    };

    //Lifecycle
    componentWillReceiveProps(nextProps) {

        if (this.props.parts !== nextProps.parts) {
            this.setState({parts: nextProps.parts});
        }

    };




    render() {

        if(this.props.type === "test"){
            return (
                <div
                    id={"panel_chapter_part_test_" + this.props.number}
                    className="chapter-part"
                >
                    <div className="row no-margin">
                        <div className="col-sm-5 no-padding">
                            <div
                                style={{borderBottom: "1px solid #f1f1f1"}}
                            >
                                <div className="chapter_info">
                                    <div className="chapter_thumb">
                                        <img src={''} alt="This is a chapter thumb" />
                                    </div>
                                    <div className="chapter_desc">
                                        <h3 className="font-18 sm-top0">
                                            {this.props.name}
                                        </h3>
                                        <div className="chapter_controls">
                                            <div className="font-16">


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-7 no-padding">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="head-subhead">
                                        <p>Total Time</p>
                                        <h3>
                                            {}
                                        </h3>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="head-subhead">
                                        <p>Video Questions</p>
                                        <h3>

                                        </h3>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="head-subhead">
                                        <p>Quiz Questions</p>
                                        <h3>

                                        </h3>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="head-subhead">
                                        <p>Status</p>
                                        <h3>
                                    <span>

                                    </span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )
        }else {
            return (
                <SortableList
                    parts={this.state.parts}
                    number={this.props.number}
                    onSortEnd={this.onSortEnd}
                    showModalDelete={this.props.showModalDelete}
                    setSelectedEditChapterPartId={this.setSelectedEditChapterPartId}
                    selectedEditChapterPartId={this.state.selectedEditChapterPartId}
                    redirect={this.props.redirect}
                    user={this.props.user}
                    updateChapterPartStatus={this.props.updateChapterPartStatus}
                     history={this.props.history}
                     pressDelay={100}
                />
            );
        }
    }
}

SortableChapters.propTypes = {
    parts: PropTypes.array.isRequired,
    number: PropTypes.number,
    showModalDelete: PropTypes.func.isRequired
};

export default SortableChapters;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/SortableChapters.js